import React from "react";
import "./Servicios.css";
import useInView from "../../hooks/useInView"; // Asegúrate de que el hook esté importado correctamente

// const serviciosData = [
//   {
//     title: "Servicio Técnico",
//     description:
//       "Ofrecemos mantenimiento preventivo y correctivo con un sistema de abono mensual, asegurando que sus equipos operen sin interrupciones. Contamos con servicio técnico residente fijo y personal altamente calificado para reparaciones integrales, garantizando un servicio eficiente y de calidad.",
//     imageUrl:
//       "http://www.autoelevadoresecharri.com/assets/images/servicio%20tecnico%201.jpg",
//   },
//   {
//     title: "Logística y Transporte",
//     description:
//       "Brindamos traslados de maquinarias, vehículos especiales y grupos electrógenos a nivel nacional. Contamos con unidades 0 km, monitoreo satelital para mayor seguridad, y camillas de 6 a 8 metros con capacidad de carga de 6T a 12T. Además, ofrecemos servicio de logística para garantizar que los equipos de nuestros clientes se movilicen sin retrasos.",
//     imageUrl:
//       "http://www.autoelevadoresecharri.com/assets/images/transporte%201.jpg",
//   },
//   {
//     title: "Servicio de Descarga",
//     description:
//       "Ofrecemos descarga de todo tipo de máquinas con personal altamente capacitado y equipos especializados de primera línea. Nos destacamos por la eficacia, eficiencia y calidad en nuestros trabajos, respaldados por nuestra experiencia y la fidelidad de nuestros clientes.",
//     imageUrl:
//       "http://www.autoelevadoresecharri.com/assets/images/descarga%201.jpg",
//   },
// ];

const Servicios = ({ servicios }) => {
  const [isInView, ref] = useInView(0.5); // 10% visible

  if (servicios.length === 0) return null;

  return (
    <div className="servicios-container" id="servicios">
      <h2 className="section-title">Servicios que Brindamos</h2>
      <div className="servicios-list">
        {servicios.map((servicio, index) => {
          return (
            <div
              key={index}
              className={`servicio-card ${isInView ? "visible" : ""}`}
              ref={ref}
            >
              <img
                src={servicio.image}
                alt={servicio.title}
                className="servicio-image"
              />
              <div className="servicio-content">
                <h3 className="servicio-title">{servicio.title}</h3>
                <p className="servicio-description">{servicio.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Servicios;
